export const matchConstants = {
    GET_SCORE: "GET_SCORE",
    ADD_POINT: "ADD_POINT",
    RESET_SCORE: "RESET_SCORE",
};